import { HTMLAttributes, forwardRef } from 'react'
import { cn } from '@/lib/utils'

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: 'mint' | 'gold' | 'brown' | 'beige' | 'red' | 'blue' | 'gray' | 'purple' | 'default'
  size?: 'sm' | 'md'
}

const variantStyles = {
  mint: 'bg-mint-100 text-mint-800',
  gold: 'bg-gold-100 text-gold-800',
  brown: 'bg-brown-100 text-brown-800',
  beige: 'bg-beige-100 text-beige-800',
  red: 'bg-red-100 text-red-800',
  blue: 'bg-blue-100 text-blue-800',
  gray: 'bg-gray-100 text-gray-800',
  purple: 'bg-purple-100 text-purple-800',
  default: 'bg-gray-100 text-gray-800',
}

const sizeStyles = {
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-2.5 py-1 text-sm',
}

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(
  ({ className, variant = 'default', size = 'sm', children, ...props }, ref) => {
    return (
      <span
        ref={ref}
        className={cn(
          'inline-flex items-center font-medium rounded-full',
          variantStyles[variant],
          sizeStyles[size],
          className
        )}
        {...props}
      >
        {children}
      </span>
    )
  }
)

Badge.displayName = 'Badge'
